import React from 'react';
import { Card, CardContent } from '../ui/card';
import { ChevronDown, X } from 'lucide-react';

const DepartmentCard = ({
  dept,
  isSelected,
  isCollapsed,
  allDepartmentsCollapsed,
  editDepartmentMode,
  onSelect,
  onToggleCollapse,
  onToggleVisibility
}) => {
  const Icon = dept.icon;

  return (
    <div className="relative">
      {/* Edit Mode Visibility Toggle */}
      {editDepartmentMode && (
        <div className="absolute -top-2 -right-2 z-10">
          <button
            onClick={(e) => { e.stopPropagation(); onToggleVisibility(dept.id); }}
            className="h-5 w-5 rounded-full bg-red-500 hover:bg-red-600 text-white flex items-center justify-center shadow-lg"
            title="Hide Department"
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      )}
      <button
        onClick={() => !editDepartmentMode && onSelect(dept.id)}
        className={`w-full text-left transition-all duration-200 ${isSelected ? 'scale-[1.02]' : 'hover:scale-[1.01]'}`}
      >
        <Card 
          className={`h-full border-2 ${isSelected ? 'border-primary' : 'border-primary/30'} cursor-pointer hover:border-primary/50`}
          style={{
            boxShadow: isSelected 
              ? '0 0 20px rgba(59, 130, 246, 0.4), 0 0 40px rgba(59, 130, 246, 0.2)'
              : '0 0 10px rgba(59, 130, 246, 0.15), 0 0 20px rgba(59, 130, 246, 0.08)'
          }}
        >
          <CardContent className={`${allDepartmentsCollapsed ? 'p-2' : 'p-2.5'}`}>
            {/* Header with collapse toggle */}
            <div 
              className="flex items-center gap-1.5 cursor-pointer"
              onClick={(e) => { if (!allDepartmentsCollapsed) { e.stopPropagation(); onToggleCollapse(dept.id); }}}
            >
              <div className={`${allDepartmentsCollapsed ? 'h-5 w-5' : 'h-6 w-6'} rounded-lg ${isSelected ? 'bg-primary' : 'bg-primary/10'} flex items-center justify-center`}>
                <Icon className={`${allDepartmentsCollapsed ? 'h-3 w-3' : 'h-3.5 w-3.5'} ${isSelected ? 'text-primary-foreground' : 'text-primary'}`} />
              </div>
              <span className={`${allDepartmentsCollapsed ? 'text-sm' : 'text-base'}`}>{dept.emoji}</span>
              {!allDepartmentsCollapsed && (
                <ChevronDown className={`h-3 w-3 ml-auto text-muted-foreground transition-transform ${isCollapsed ? '-rotate-90' : ''}`} />
              )}
            </div>
            <h3 className={`font-semibold ${allDepartmentsCollapsed ? 'text-[10px] mt-0.5' : 'text-xs mt-1'} truncate`}>
              {dept.name.split(' ')[0]}
            </h3>
            
            {/* Collapsible Content */}
            {!allDepartmentsCollapsed && !isCollapsed && (
              <div className="mt-1.5 space-y-0.5">
                <div className="flex items-center justify-between text-[10px]">
                  <span className="text-muted-foreground">Active</span>
                  <span className="font-medium text-green-600">{dept.active}</span>
                </div>
                <div className="flex items-center justify-between text-[10px]">
                  <span className="text-muted-foreground">Inactive</span>
                  <span className="font-medium text-orange-500">{dept.inactive}</span>
                </div>
                <div className="border-t pt-0.5 mt-0.5">
                  <div className="flex items-center justify-between text-[10px]">
                    <span className="text-muted-foreground">Total</span>
                    <span className="font-bold text-primary">{dept.total}</span>
                  </div>
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      </button>
    </div>
  );
};

export default DepartmentCard;